<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_payment_method_banner.jpg')" alt="入出金方法">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <div class="sup-subtab-wrap">
          <router-link class="sup-subtab" to="/page/sup-withdraw-bank">
            銀行振込
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-withdraw-mtpay">
            Match Pay
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-withdraw-vega">
            VegaWallet
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-withdraw-jeton">
            Jetonbank
          </router-link>
          <router-link class="sup-subtab sup-subtab--active" to="/page/sup-withdraw-crypto">
            仮想通貨
          </router-link>
        </div>
        <h1 class="sup-page-title">
          仮想通貨での出金方法
        </h1>
        <div class="sup-steps-box">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 1
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ 残高表示部分ををタップ</p>
              <p>➋ 「出金」をタップ</p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_withdraw_crypto1.jpg')" alt="ステップ1">
            </div>
          </div>
          <hr class="sup-step-divider">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 2
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ 「仮想通貨」を選択</p>
              <p>➋ 出金通貨およびネットワークを選択</p>
              <p>➌ 金額を入力</p>
              <p>➍ 出金先アドレスを入力</p>
              <p>➎ 出金パスワードを入力</p>
              <p>➏ 「送信する」をタップすると出金申請を提出完了</p>
            </div>
            <p class="sup-step-caution">
              ※【注意】XRPで出金する場合はタグの入力が必須です。未入力の場合、資金を失う恐れがあります。
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_withdraw_crypto2.jpg')" alt="ステップ2-1">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_withdraw_crypto3.jpg')" alt="ステップ2-2">
            </div>
          </div>
          <div class="sup-step-img-wrap">
            <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_withdraw_crypto4.jpg')" alt="XRP注意">
          </div>
          <hr class="sup-step-divider">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 3
            </p>
            <p class="sup-step-desc">
              出金申請の審査が終了後に出金完了
            </p>
            <p class="sup-step-caution">
              ※出金申請後に出金審査完了までお待ちください。出金処理が完了すると通知メールが送信されます。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
